export default __webpack_public_path__ + "static/media/icon-in-circle.2304219e.svg";